import React,{useEffect} from 'react'
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect

  } from "react-router-dom";
import Index from 'Pages'; 
import Navbar from 'components/navbar';
import Topic from 'Pages/Topic';
import Footer from 'components/footer';
import Home from 'Pages/Home';
import Search from 'Pages/Search';
import Detail from 'Pages/Detail';
import Login from 'Pages/Login'
import Cookie from 'universal-cookie'
import { useDispatch } from 'react-redux';
import { logout } from 'redux/actions/auth';
const cookie=new Cookie()
const token=cookie.get('login_cookie_forum')
const profile=cookie.get('profile_cookie_forum')
const Logout=()=>{
    const dispatch=useDispatch()
    useEffect(()=>{
        dispatch(logout(`redirect=${window.location.href}`))
    },[])
    return(
        <p>Loading..</p>
        // <Redirect to={`/login?redirect=${window.location.href}`}/>
    )
}
export default function routes() {
    const withNavbar=()=>{
        if(token!==undefined){
            return(
                <div>
                    <Navbar/>
                    <Route path="/topic"  exact render={()=><Topic token={token} profile={profile}/>}/>
                    <Route path='/forum' token={token} profile={profile} exact component={Home}/>
                    <Route path="/search" token={token} profile={profile} exact component={Search}/>
                    <Route path="/detail/:id" token={token} profile={profile} exact component={Detail}/>
                    <Footer/>
    
                </div>
            )
        }else{
            return <Logout/>
        }
        
    }
        
    
    return (
        <div>
            <Router>
                <Switch>
                    <Route  path="/" exact render={()=><Index token={token}/>}/>
                    <Route  path="/login" exact render={()=><Login />}/>
                    {withNavbar()}
                </Switch>
            </Router>
        </div>
    )
}
